import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { PhoneNumberWithPrefixRequest } from '@web/shared/module/dictionary';

@jsonObject
export class PublicSubscriptionShippingAddressUpdateRequest {
  @jsonMember(String)
  public readonly firstName!: string;

  @jsonMember(String)
  public readonly lastName!: string;

  @jsonMember(PhoneNumberWithPrefixRequest)
  public readonly phone!: PhoneNumberWithPrefixRequest;

  @jsonMember(String)
  public readonly email!: string;

  @jsonMember(String)
  public readonly countryId!: Guid;

  @jsonMember(String)
  public readonly streetLine1!: string;

  @jsonMember(String)
  public readonly streetLine2?: Nillable<string>;

  @jsonMember(String)
  public readonly postCode!: string;

  @jsonMember(String)
  public readonly city!: string;

  @jsonMember(String)
  public readonly state?: Nillable<string>;

  @jsonMember(String)
  public readonly companyName?: Nillable<string>;

  @jsonMember(String)
  public readonly shippingMethod?: Nillable<Guid>;

  @jsonMember(String)
  public readonly shippingPoint?: Nillable<string>;

  public constructor(
    private readonly data: {
      city: string;
      companyName?: Nillable<string>;
      countryId: Guid;
      email: string;
      firstName: string;
      lastName: string;
      phone: PhoneNumberWithPrefixRequest;
      postCode: string;
      state?: Nillable<string>;
      streetLine1: string;
      streetLine2?: Nillable<string>;
      shippingMethod?: Nillable<Guid>;
      shippingPoint?: Nillable<string>;
    },
  ) {
    this.city = this.data.city;
    this.companyName = this.data.companyName;
    this.countryId = this.data.countryId;
    this.email = this.data.email;
    this.firstName = this.data.firstName;
    this.lastName = this.data.lastName;
    this.phone = this.data.phone;
    this.postCode = this.data.postCode;
    this.state = this.data.state;
    this.streetLine1 = this.data.streetLine1;
    this.streetLine2 = this.data.streetLine2;
    this.shippingMethod = this.data.shippingMethod;
    this.shippingPoint = this.data.shippingPoint;
  }
}
